import { aplicaFiltroEmURL } from '../../src/vue/shared/filtro/helpers/index';

document.addEventListener('DOMContentLoaded', function() {
  inicializarIconesOrdenacao();
});

function ordenaNfesEmitidas(orderBy) {
  const theadNumero = $('#thead-ordena-nfes-emitidas-numero');
  const theadData = $('#thead-ordena-nfes-emitidas-data');
  if (theadNumero.length < 1 || theadData.length < 1) return;

  removeIconesOrdenacao();

  const ordenacaoAtual = getOrdenacaoAtual();
  const isAsc = ordenacaoAtual === orderBy;
  const novaOrdenacao = isAsc ? `${orderBy}_asc` : orderBy;

  const iconHtml = `
    <i class="fa fa-sort-asc ${isAsc ? 'active' : ''}"></i>
    <i class="fa fa-sort-desc ${!isAsc ? 'active' : ''}"></i>
  `;

  if (orderBy === 'numero_nfe') {
    theadNumero.append(iconHtml);
    theadData.text(window.t('interface.data'));
  } else if (orderBy === 'dthr_referencia') {
    theadData.append(iconHtml);
    theadNumero.text(window.t('interface.serie_number').replaceAll(' ', ''));
  } else {
    return;
  }

  aplicaFiltroEmURL('ordem', novaOrdenacao);
}

function getOrdenacaoAtual() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('ordem') || '';
}

function removeIconesOrdenacao() {
  const theadNumero = $('#thead-ordena-nfes-emitidas-numero');
  const theadData = $('#thead-ordena-nfes-emitidas-data');
  if (theadNumero.length < 1 || theadData.length < 1) return;

  theadNumero.find('i').remove();
  theadData.find('i').remove();
}

function inicializarIconesOrdenacao() {
  const ordenacaoAtual = getOrdenacaoAtual();
  const theadNumero = $('#thead-ordena-nfes-emitidas-numero');
  const theadData = $('#thead-ordena-nfes-emitidas-data');

  if (theadNumero.length < 1 || theadData.length < 1) return;

  removeIconesOrdenacao();

  const isAsc = ordenacaoAtual.endsWith('_asc');
  const baseOrder = ordenacaoAtual.replace('_asc', '');

  let targetElement;
  if (baseOrder === 'numero_nfe') {
    targetElement = theadNumero;
  } else if (baseOrder === 'dthr_referencia') {
    targetElement = theadData;
  } else {
    return;
  }

  targetElement.append(`
    <i class="fa fa-sort-asc ${isAsc ? 'active' : ''}"></i>
    <i class="fa fa-sort-desc ${!isAsc ? 'active' : ''}"></i>
  `);
}

export function handleSkeletonRow() {
  let skeletonRow = '';
  let celulas = [
    "skeleton-checkbox",
    "skeleton-icon",
    "skeleton-serie",
    "skeleton-cfop",
    "skeleton-data",
    "skeleton-cliente",
    "skeleton-referencias",
    "skeleton-total-produtos",
    "skeleton-total-nfe",
    "skeleton-status",
    "skeleton-icones",
    "skeleton-acoes"
  ]
  let resCol = ""
  for (let i = 0; i < celulas.length; i++) {
    resCol += `<td><div class="skeleton-col ${celulas[i]}"></div></td>`
  }
  const SKELETON_ROW_COUNT = 15;
  for (let i = 0; i < SKELETON_ROW_COUNT; i++) {
    skeletonRow += `
      <tr class="skeleton-row">
        ${resCol}
      </tr>
    `;
  }

  const nfeTable = $(document).find('#table-body-nfes-emitidas');
  if (nfeTable.length < 1) return;

  nfeTable.removeData('operation');
  nfeTable.append(skeletonRow);
}

export function removeSkeletonRow(count) {
  const nfeTable = $(document).find('#table-body-nfes-emitidas');
  if (nfeTable.length < 1) return;

  setTimeout(() => {
    $('.skeleton-row').remove();
    updateTotalItemsLoaded(count);
  }, 500);
}

function carregarMaisNotasFiscais(event) {
  event.preventDefault();

  handleSkeletonRow()

  let total = valorConfigPagina().total;
  let size = valorConfigPagina().size;

  const tableNfe = $('.table-nfe-emitidas');
  const bodyNotaFiscal = $('#nota_fiscals-index');
  $('#table-body-nfes-emitidas').data('operation', 'carregar-mais-notas');
  const sessionStorage = window.sessionStorage;

  if (bodyNotaFiscal.length > 0 && tableNfe.length > 0) {
    if (sessionStorage.getItem('filtro_aplicado')) {
      total = valorConfigPagina().total;
      size = valorConfigPagina().size;
      currentPageNfesEmitidas = 1;
      sessionStorage.removeItem('filtro_aplicado');
    }
    
    if (currentPageNfesEmitidas < total) {
      const urlParams = new URLSearchParams(window.location.search);
      const params = {};
      
      for (const [key, value] of urlParams.entries()) {
        if (['page', '_', 'filtro_aplicado'].includes(key)) continue;
        
        if (params[key]) {
          if (!Array.isArray(params[key])) {
            params[key] = [params[key]];
          }
          params[key].push(value);
        } else {
          params[key] = value;
        }
      }

      params.page = currentPageNfesEmitidas + 1;
      
      $(event.target).html(`
        <i class="spinner-border"></i>
      `);
      $(event.target).prop('disabled', true);

      $.rails.ajax({
        url: '/nota_fiscals.js',
        type: 'GET',
        data: params,
        success: function() {
          currentPageNfesEmitidas++;
          updateTotalItemsLoaded();
          window.scrollBy(0, -100);
          $(event.target).html(`
            Carregar mais <i class="fa fa-chevron-down"></i>
          `);
        }, 
        finally: () => {
          removeSkeletonRow();
        }
      });
    }
  }
}

function removeNotaForaDoFiltro(el) {
  const _el = $(el).parent().parent();
  const deveRemover = $(el).attr('checked', false) && _el.data('selecao-persistida');

  if (deveRemover) {
    _el.remove();
  }
}

Object.assign(globalThis, {
  ordenaNfesEmitidas,
  handleSkeletonRow,
  removeSkeletonRow,
  carregarMaisNotasFiscais,
  removeNotaForaDoFiltro
});